import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicTableFilters from "../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters"
import Toggle from "../../../common/AdminCommonComponents/Toggle/Toggle"
import DynamicCardRow from "../../DynamicCardRow/DynamicCardRow"

const TrainingModules = ({ setNewModuleCreation }) => {
  const cardsData = [
    { title: "TOTAL Training modules uploaded".toUpperCase(), value: 0 },
    { title: "active Resources".toUpperCase(), value: 0 },
    { title: "Webinars conducted".toUpperCase(), value: 0 },
    { title: "Most Accessed guides/resource".toUpperCase(), value: 0 },
  ]

  const tableData = [
    { moduleID: "TM001", title: "Seo Basics", type: "Video", uploadedDate: "01-11-2024", status: <Toggle theme="yellow" /> },
    { moduleID: "TM002", title: "product Photography", type: "Article", uploadedDate: "01-11-2024", status: <Toggle theme="yellow" /> },
    { moduleID: "TM001", title: "Seo Basics", type: "Video", uploadedDate: "01-11-2024", status: <Toggle theme="yellow" /> },
    { moduleID: "TM001", title: "Seo Basics", type: "Video", uploadedDate: "01-11-2024", status: <Toggle theme="yellow" /> },
    { moduleID: "TM001", title: "Seo Basics", type: "Video", uploadedDate: "01-11-2024", status: <Toggle theme="yellow" /> },
  ]

  const columns = [
    {
      name: "Module ID",
      selector: (row) => row.moduleID,
    },
    {
      name: "Title",
      selector: (row) => row.title,
    },
    {
      name: "Type",
      selector: (row) => row.type,
    },
    {
      name: "Uploaded Date",
      selector: (row) => row.uploadedDate,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      center: true,
    },
    {
      name: "Actions",
      cell: () => (
        <div className="d-flex align-items-center gap-2">
          <button style={{ all: "unset" }}>Edit</button>
          <button style={{ all: "unset" }}>Delete</button>
          <button style={{ all: "unset" }}>View</button>
        </div>
      ),
    },
  ]

  return (
    <>
      <div className="shadow bg-white p-3 mt-3">
        <div className="mb-3 fw-semibold fs-4">Overview</div>
        <DynamicCardRow cards={cardsData} />
      </div>

      <div className="my-3">
        <DynamicButton theme="blue" onClick={() => setNewModuleCreation(prev => !prev)}>Create Module</DynamicButton>
      </div>

      <div className="bg-white shadow p-1">
        <DynamicTableFilters componentName="Content Management Training And Resources" />
      </div>
        <DynamicDatatable data={tableData} columns={columns} type="yellow" pagination />
    </>
  )
}

export default TrainingModules
